import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, reactive, readonly, toRefs } from "vue";

type Modal = "onboarding" | "languageSelector" | "support";

type State = Record<Modal, { isOpen: boolean }>;

export const useModalStore = defineStore("modal", () => {
  const state = reactive<State>({
    onboarding: { isOpen: false },
    languageSelector: { isOpen: false },
    support: { isOpen: false }
  });

  const isAnyModalOpen = computed<boolean>(() =>
    Object.values(state).some((state) => state.isOpen)
  );

  const setModalState = (modal: keyof State, isOpen: boolean): void => {
    if (isOpen && isAnyModalOpen.value) {
      return;
    }

    state[modal].isOpen = isOpen;
  };

  return {
    ...toRefs(readonly(state)),

    isAnyModalOpen,

    setModalState
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useModalStore, import.meta.hot));
}
